import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {Icon, Typography} from '@material-ui/core';
import classNames from 'classnames';

const styles = theme => ({
	root: {}
});

class MyUserHeader extends Component {
	render()
	{
		const {classes} = this.props;
		return (
			<div className = {classNames(classes.root, "flex flex-1 flex-col sm:flex-row items-center justify-between p-24")}>
				<div className="flex flex-1 items-center">
                    <div className="flex items-center">
                        <Icon className="text-32 mr-12">people</Icon>
                        <Typography variant="title">My Profile</Typography>
                    </div>
                </div>
            </div>
		);
	}
}

export default withStyles(styles, {withTheme: true})(MyUserHeader);